import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const articleImages: Record<string, string> = {
  'article-beginner-01': 'https://readdy.ai/api/search-image?query=First%20person%20view%20entering%20a%20dark%20fantasy%20dungeon%20entrance%2C%20torch%20in%20hand%20illuminating%20rough%20stone%20walls%20covered%20in%20moss%2C%20ancient%20wooden%20door%20slightly%20ajar%20with%20warm%20light%20spilling%20through%2C%20cinematic%20game%20environment%20concept%20art%2C%20rich%20atmospheric%20lighting%20with%20amber%20and%20dark%20brown%20tones&width=800&height=560&seq=article-beginner-01&orientation=landscape',
  'article-beginner-03': 'https://readdy.ai/api/search-image?query=Heavily%20armored%20warrior%20standing%20guard%20in%20dark%20dungeon%20corridor%2C%20massive%20shield%20reflecting%20torchlight%2C%20ornate%20plate%20armor%20with%20battle%20scars%2C%20defensive%20stance%20ready%20for%20combat%2C%20dark%20fantasy%20character%20portrait%2C%20dramatic%20chiaroscuro%20lighting%20with%20warm%20amber%20highlights&width=800&height=560&seq=article-beginner-03&orientation=landscape',
  'article-char-01': 'https://readdy.ai/api/search-image?query=Elegant%20moon%20elf%20female%20character%20with%20silver%20hair%20and%20pale%20skin%20in%20dark%20cave%20setting%2C%20ethereal%20silver%20white%20glow%20emanating%20from%20her%20hands%2C%20wearing%20flowing%20elven%20robes%20with%20lunar%20motifs%2C%20melancholic%20expression%2C%20dark%20fantasy%20character%20art%2C%20soft%20moonlight%20contrasting%20with%20cave%20darkness&width=800&height=560&seq=article-char-01&orientation=landscape',
  'article-story-01': 'https://readdy.ai/api/search-image?query=Ancient%20stone%20mural%20carved%20into%20cave%20wall%20depicting%20epic%20battle%20scene%20between%20elves%20and%20goblin%20armies%20under%20a%20dark%20moon%2C%20mysterious%20runes%20and%20glowing%20crystals%20embedded%20in%20the%20carving%2C%20torchlight%20revealing%20hidden%20details%2C%20dark%20fantasy%20archaeological%20discovery%20scene%2C%20rich%20amber%20lighting&width=800&height=560&seq=article-story-01&orientation=landscape',
  'article-map-01': 'https://readdy.ai/api/search-image?query=Weathered%20parchment%20style%20fantasy%20dungeon%20map%20with%20detailed%20room%20layouts%20and%20mysterious%20markings%2C%20compass%20rose%20in%20corner%2C%20candle%20wax%20drips%20on%20edges%2C%20torchlight%20reflecting%20off%20the%20aged%20paper%20surface%2C%20cartography%20aesthetic%20with%20sepia%20and%20warm%20brown%20tones&width=800&height=560&seq=article-map-01&orientation=landscape',
  'article-equip-01': 'https://readdy.ai/api/search-image?query=Collection%20of%20fantasy%20weapons%20and%20armor%20displayed%20on%20tiered%20pedestals%20in%20dark%20underground%20vault%2C%20legendary%20sword%20glowing%20with%20golden%20light%20at%20the%20top%2C%20various%20shields%20axes%20and%20staves%20on%20lower%20tiers%2C%20treasure%20vault%20atmosphere%20with%20warm%20torchlight&width=800&height=560&seq=article-equip-01&orientation=landscape',
  'article-boss-01': 'https://readdy.ai/api/search-image?query=Giant%20spider%20queen%20boss%20in%20dark%20underground%20cavern%2C%20massive%20web%20spanning%20across%20the%20chamber%2C%20glowing%20red%20eyes%20and%20crystalline%20carapace%20reflecting%20torchlight%2C%20adventurers%20in%20defensive%20formation%20below%2C%20epic%20dark%20fantasy%20boss%20battle%20scene%20with%20dramatic%20amber%20and%20crimson%20lighting&width=800&height=560&seq=article-boss-01&orientation=landscape',
  'article-boss-02': 'https://readdy.ai/api/search-image?query=Epic%20final%20boss%20confrontation%20with%20massive%20goblin%20king%20on%20dark%20throne%20surrounded%20by%20treasure%20and%20glowing%20crystals%2C%20hero%20standing%20defiantly%20with%20sword%20raised%2C%20dramatic%20lighting%20with%20intense%20golden%20and%20emerald%20energy%20swirling%2C%20cinematic%20dark%20fantasy%20battle%20scene%20with%20epic%20scale&width=800&height=560&seq=article-boss-02&orientation=landscape',
};

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat?.name || slug;
}

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选攻略
            </h2>
            <p className="text-foreground-500 text-sm mt-1">编辑部推荐的高质量内容</p>
          </div>
          <Link
            to="/category/beginner-guide"
            className="text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部攻略 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {featured.slice(0, 4).map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col sm:flex-row bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-48 h-44 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-between">
                <div>
                  <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2">
                    {getCategoryName(article.category)}
                  </span>
                  <h3 className="font-heading font-bold text-foreground-950 text-base leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-sm mt-2 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                  <span><i className="ri-time-line mr-1"></i>{article.readTime}</span>
                  <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                  <span><i className="ri-user-line mr-1"></i>{article.author}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-6">
          {featured.slice(4, 7).map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="h-40 md:h-44 overflow-hidden">
                <img
                  src={articleImages[article.imageSeq]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2.5 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2">
                  {getCategoryName(article.category)}
                </span>
                <h3 className="font-heading font-bold text-foreground-950 text-base leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span>{article.readTime}</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}